import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', () => {
    const getBlock = (swiper) => swiper.el.closest('[data-component="block-adhd-pass"]');

    const getDefaultTitles = (block) =>
        (block?.dataset.defaultTitles || '').split('|').filter(Boolean);

    // Caption card follows the active slide: text, kicker „Seite N · Titel“, width.
    const syncCaption = (swiper) => {
        const block = getBlock(swiper);
        if (!block) {
            return;
        }

        const activeSlide = swiper.slides[swiper.activeIndex];
        const bodyIntro = block.querySelector('[data-adhd-pass-body-intro]');
        const kicker = block.querySelector('[data-adhd-pass-kicker]');
        const caption = block.querySelector('.adhd-pass__caption');

        if (bodyIntro && activeSlide?.dataset.bodyIntro !== undefined) {
            bodyIntro.textContent = activeSlide.dataset.bodyIntro;
        }

        if (kicker && activeSlide) {
            const number = swiper.activeIndex + 1;
            const title = activeSlide.dataset.title || getDefaultTitles(block)[swiper.activeIndex] || '';
            kicker.textContent = title ? `Seite ${number} · ${title}` : `Seite ${number}`;
        }

        if (caption && activeSlide) {
            const width = Math.round(activeSlide.getBoundingClientRect().width);
            if (width > 0) {
                caption.style.maxWidth = `${width}px`;
            }
        }
    };

    const adhdSliderContainers = document.querySelectorAll(
        '.swiper-container.adhd-slider'
    );

    adhdSliderContainers.forEach((adhdSliderContainer) => {
        if (adhdSliderContainer.swiper) {
            return;
        }

        const swiperID = adhdSliderContainer.parentElement.getAttribute('data-swiperid');
        const scope = `[data-swiperid="${swiperID}"]`;

        // One snap per slide so the last is reachable: swiper#3108
        const syncSnapGrid = (swiper) => {
            if (!swiper.slidesGrid?.length) {
                return;
            }
            swiper.snapGrid = [...swiper.slidesGrid];
            swiper.pagination?.render();
            swiper.pagination?.update();
        };

        new Swiper(adhdSliderContainer, {
            modules: [Navigation, Pagination],
            spaceBetween: 10,
            slidesPerView: 1,
            watchOverflow: true,
            centerInsufficientSlides: true,
            // Arrows wrap around: last page → first page and back.
            rewind: true,
            navigation: {
                prevEl: `${scope} .adhd-pass__arrow--prev`,
                nextEl: `${scope} .adhd-pass__arrow--next`,
            },
            pagination: {
                el: `${scope} .swiper-pagination`,
                clickable: true,
                renderBullet: function (index, className) {
                    return `<span class="${className}">${index + 1}</span>`;
                }
            },
            breakpoints: {
                300: {
                    slidesPerView: 1.1,
                },
                768: {
                    slidesPerView: 1.6,
                },
                1280: {
                    slidesPerView: 2,
                },
            },
            on: {
                init: (swiper) => {
                    syncSnapGrid(swiper);
                    syncCaption(swiper);
                },
                breakpoint: (swiper) => {
                    syncSnapGrid(swiper);
                    syncCaption(swiper);
                },
                resize: (swiper) => {
                    syncSnapGrid(swiper);
                    syncCaption(swiper);
                },
                slideChange: syncCaption,
                slideChangeTransitionEnd: syncCaption,
            },
        });
    });
});
